import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "use"];
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { toPx } from '../utils/Styles';
import { useFoundationsReadinessTracking } from '../utils/useFoundationsReadinessTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollWrapper = styled.div.withConfig({
  displayName: "UISection__ScrollWrapper",
  componentId: "sc-188czzc-0"
})(["height:", ";&&{", ";}& >:last-child{margin-bottom:0;}"], ({
  height
}) => height && toPx(height), ({
  flush
}) => flush && `margin-bottom: 0`);
const UISection = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className,
      use
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  useFoundationsReadinessTracking();
  return /*#__PURE__*/_jsx(ScrollWrapper, Object.assign({}, rest, {
    className: classNames("is--module namespaced-hack-section", className, use === 'island' && 'is--island'),
    ref: ref
  }));
});
UISection.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  use: PropTypes.oneOf(['default', 'island']).isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UISection.defaultProps = {
  flush: false,
  use: 'default'
};
UISection.displayName = 'UISection';
export default UISection;